import environment from "environment";

function RouteEnum() {
    return {
        HOME: environment.basePathDeploy + "/",
        ACCESSO_REGISTRAZIONE: environment.basePathDeploy + "/accesso-registrazione",
        REGISTRAZIONE_EFFETTUATA: environment.basePathDeploy + "/registrazione-effettuata",
        CONFERMA_REGISTRAZIONE: environment.basePathDeploy + "/conferma-registrazione",
        PREVENTIVO: environment.basePathDeploy + "/preventivo",
        VANTAGGI: environment.basePathDeploy + "/vantaggi",
        COSA_SERVE: environment.basePathDeploy + "/cosaserve",
        COSA_E: environment.basePathDeploy + "/cose",
        CHI_SIAMO: environment.basePathDeploy + "/chi",
        ACCESSO: environment.basePathDeploy + "/accesso",
        ACCESSO_EFFETTUATO: environment.basePathDeploy + "/accesso-effettuato",
        RICHIESTA: environment.basePathDeploy + "/richiesta",
        DASHBOARD: environment.basePathDeploy + "/dashboard",
        PRIVACY: environment.basePathDeploy + "/privacy",
        RECUPERO_PASSWORD: environment.basePathDeploy + "/recupero-password",
        CAMBIO_PASSWORD: environment.basePathDeploy + "/cambio-password",
        FIRMA_DOCUMENTI_ISTRUTTORIA: environment.basePathDeploy + "/documenti-istruttoria",
        RICHIESTA_PREVENTIVO: environment.basePathDeploy + "/richiesta-preventivo",
    };
}

export default RouteEnum;
